(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher-flags"] && !Shopify.designMode) return;
  try {
    (function() {
  var sw = document.getElementById('nomadic-lang-switcher');
  if (!sw) return;
  var btn = sw.querySelector('.nomadic-lang-toggle');
  var dd = sw.querySelector('.nomadic-lang-dropdown');
  var form = document.getElementById('nomadic-localization-form');
  var input = document.getElementById('nomadic-locale-code');
  sw.querySelectorAll('.nomadic-lang-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      input.value = opt.dataset.locale;
      form.submit();
    });
  });
  btn.addEventListener('click', function() {
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    dd.setAttribute('aria-hidden', String(open));
  });
  document.addEventListener('click', function(e) {
    if (!sw.contains(e.target)) {
      btn.setAttribute('aria-expanded', 'false');
      dd.setAttribute('aria-hidden', 'true');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
